import apiClient from '@/services/api'
import { prepareFilterWithEmployeeLegalEntities } from '@/utils/payment-type-legal-entity-filter'

export default {
  async getFullInfo({ dispatch }, _) {
    try {
      await Promise.all([dispatch('getStatuses'), dispatch('getActionGroups'), dispatch('getTypes')])
    } catch (error) {
      throw error.message
    }
  },
  async getStatuses({ commit }, _) {
    try {
      const { data } = await apiClient.get('/api/point_system/statuses')

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }

      commit('SET_STATUSES', data.items)
    } catch (error) {
      throw error.message
    }
  },
  async getActionGroups({ commit }, _) {
    try {
      const { data } = await apiClient.get('/api/point_system/action_groups')

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }

      commit('SET_GROUPS', data.items)
    } catch (error) {
      throw error.message
    }
  },
  async getTypes({ commit }, _) {
    try {
      const { data } = await apiClient.get('/api/point_system/action_types')

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }

      commit('SET_TYPES', data.items)
    } catch (error) {
      throw error.message
    }
  },
  async getStatistic({ state }, filters) {
    try {
      const { data } = await apiClient.get('/api/point_system/action/statistic', {
        params: { ...filters },
        cancelPreviousRequests: true
      })

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }

      return Object.entries(data.statistic).map(([mainKey, mainValue]) => ({
        key: mainKey,
        title: state.types.find(item => item.type === mainKey)?.type_name,
        ...mainValue,
        sub_types: Object.entries(mainValue.sub_types).map(([subKey, subValue]) => ({
          key: subKey,
          value: subValue,
          title: state.types.find(subtype => subtype.sub_type === subKey)?.sub_type_name
        }))
      }))
    } catch (error) {
      throw error.message
    }
  },
  async getAction({ commit }, filters) {
    try {
      const { data } = await apiClient.get('/api/point_system/action', {
        params: { ...filters },
        cancelPreviousRequests: true
      })

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }

      return data
    } catch (error) {
      throw error.message
    }
  },
  async postAction({ dispatch, rootState }, { action_type_id, associate_id, value, reason }) {
    try {
      const { data } = await apiClient.post('/api/point_system/action', {
        action_type_id,
        associate_id,
        value,
        reason
      })

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }
      const associate = rootState.profile.associate

      dispatch(
        'profile/setAssociate',
        {
          ...associate,
          point_system: data.point_system
        },
        { root: true }
      )
    } catch (error) {
      throw error.message
    }
  },
  async postRecalibration({ dispatch, rootState }, { associate_id }) {
    try {
      const { data } = await apiClient.post('/api/point_system/recalibrate', {
        associate_id
      })

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }

      const associate = rootState.profile.associate

      dispatch(
        'profile/setAssociate',
        {
          ...associate,
          point_system: data.point_system
        },
        { root: true }
      )
    } catch (error) {
      throw error.message
    }
  },
  async postRecalibrationProject({ rootState }, _) {
    try {
      const { data } = await apiClient.post('/api/point_system/project/recalibrate', {
        project_id: rootState.applicationState.currentProject.id
      })

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }
    } catch (error) {
      throw error.message
    }
  },
  async postRollback({ dispatch, rootState }, { reason, point_system_action_id }) {
    try {
      const { data } = await apiClient.post('/api/point_system/rollback', {
        reason,
        point_system_action_id
      })

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }

      const associate = rootState.profile.associate

      dispatch(
        'profile/setAssociate',
        {
          ...associate,
          point_system: data.point_system
        },
        { root: true }
      )
    } catch (error) {
      throw error.message
    }
  },
  async getLeaderboard({ rootState }, { filter, page, size }) {
    const currentPaymentType = rootState.applicationState.currentPaymentTypeName
    const paymentTypes =
      currentPaymentType === 'All' ? (filter.payment_types ?? filter.payment_type) : [currentPaymentType.toLowerCase()]
    const normalizedFilter = prepareFilterWithEmployeeLegalEntities({
      filter,
      paymentTypeKey: 'payment_types',
      legalEntityKey: 'legal_entities',
      paymentTypes
    })

    try {
      const { data } = await apiClient.post(
        '/api/point_system/leaderboard',
        {
          project_id: rootState.applicationState.currentProject.id,
          page,
          size,
          filter: {
            ...normalizedFilter,
            unverified: filter.unverified && true,
            payment_type: currentPaymentType === 'All' ? filter.payment_type : currentPaymentType
          }
        },
        {
          cancelPreviousRequests: true
        }
      )

      if (data.error_code && data.error_code !== '0') {
        throw new Error(`${data.msg}`)
      }

      return data
    } catch (error) {
      throw error.message
    }
  }
}
